
$('.finance-box__title').click(function(){
  $('.finance-box__content').slideToggle();
  $(this).toggleClass('finance-box__title--open');
});

$(function(){

   //Magnific popup
  $('.image_cont').magnificPopup({
  delegate: 'img', // child items selector, by clicking on it popup will open
  type: 'image',
    gallery:{
    enabled:true
  	}
	});

  
  //Hide button if 4th image does not exist
  if ($(".image_cont .image:nth-child(4)").length) {
   	$('.show_images').css('display', 'inline-block');    
	}

  if ($(".image_cont .image").length == 1) {
   	$(".image_cont .image").css('width', '100%');
	}

  if ($(".image_cont .image").length == 2) {
   	$(".image_cont .image").css('width', '100%');
	}
 
  //Hide if more than 3 pictures on product page
	$('.show_images').click(function() {
  		$('.image_cont .image').css('display', 'inline-block');
      	$(this).css('display', 'none');
      	$('.hide_images').css('display', 'inline-block');
	});
  
  // Hide button on click
  $('.hide_images').click(function() {
    $('.image_cont .image:nth-child(1n+4)').css('display', 'none');
    $(this).css('display', 'none');
    $('.show_images').css('display', 'inline-block');
});


  // Reponsive Video

  if ($(window).width() < 1024) {

  $('iframe[src*="youtube.com"]').wrap('<div class="flex-video"></div>');

  }


  // Navigation
  $('.menu-open').click(function(){
    $('.navigation').toggleClass('show-for-large');
  });


  $('nav .menu>.menu-item-with-children>a').click(function(e){
    //console.log($(window).width());
    if ($(window).width() < (1007)) {
      e.preventDefault();
      $($($(this)[0]).parent().find('div:first')[0]).toggleClass('show-nav-item');
      return false;
    }
    else {
      return true;
    }
  });

  var listView = localStorage.listView;
  if(listView === '1'){
    $('#gridView').addClass('unchecked');
    showListView();
  }

  $('#listView').click(function(){
    showListView();
    localStorage.listView = 1;
  });

  $('#gridView').click(function(){
    $('.productGrid').addClass('small-up-2 large-up-3').removeClass('small-up-12 listView');
    $('#gridView').removeClass('unchecked');
    localStorage.listView = 0;
  });


  // Cookies
  if (localStorage.cookiesConfirmed == 1) {
    $('.cookie-banner').remove();
  }

  $('#confirmCookies').on('click', function(){
    localStorage.cookiesAcknowledged = 1;
    $('.cookie-banner').remove();
    return true;
  });

  verifyCookieFeatures();



  /* collection page: */
  $(".filters .button").click(function(e){
    e.preventDefault();

    $(".filter-menu").toggleClass("show");

    return false;
  });

  /* Product Page */
  $('.carousel').slick({ slidesToShow: 1, slidesToScroll: 1, lazyLoad: 'ondemand', arrows: false, fade: true, dots: false, waitForAnimate: false, draggable: false, accessibility: false});
  $('.carouselNav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.carousel',
    centerMode: true,
  });

  var oldIndex = '0';

  $('.carouselNav .slick-slide').on('click', function (event) {
    $('.carousel').slick('slickGoTo', $(this).data('slickIndex'));
    oldIndex = $('.carousel .slick-active').attr('data-slick-index');
  });
  $('.carouselNav').on('mouseenter', '.slick-slide', function (e) {
    oldIndex = $('.carousel .slick-active').attr('data-slick-index');
    var $currTarget = $(e.currentTarget),
        index = $currTarget.data('slick-index'),
        slickObj = $('.carousel').slick('getSlick');

    slickObj.slickGoTo(index);
  });

  $('.carouselNav').on('mouseleave', '.slick-slide', function (e) {
    var $currTarget = $(e.currentTarget),
        index = $currTarget.data('slick-index'),
        slickObj = $('.carousel').slick('getSlick');
    slickObj.slickGoTo(oldIndex);
  });

  $(".quantity-selector").on("input",function(){
    if (this.value.length > 3) {
      this.value = this.value.slice(0,3);
    }
  });


});

function verifyCookieFeatures(){
  /* if(localStorage.cookieAnalytics == 'false'){
    window['ga-disable-UA-37475141-1'] = true;
  }*/
  if(localStorage.cookiesAcknowledged == 1){
    $('.cookie-banner').remove();
  }
}

function showListView(){
  $('.productGrid').removeClass('small-up-2 large-up-3').addClass('small-up-12 listView');
  $('#gridView').addClass('unchecked');
}


// Shopify
function is_touch_device() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e) {
    return false;
  }
}

function zoomAmount()
{
  return 3;
}

;(function( $, window, document, undefined )
    {
        $.fn.doubleTapToGo = function( params )
        {
            if( !( 'ontouchstart' in window ) &&
                !navigator.msMaxTouchPoints &&
                !navigator.userAgent.toLowerCase().match( /windows phone os 7/i ) ) return false;

            this.each( function()
            {
                var curItem = false;

                $( this ).on( 'click', function( e )
                {
                    var item = $( this );
                    if( item[ 0 ] != curItem[ 0 ] )
                    {
                        e.preventDefault();
                        curItem = item;
                    }
                });

                $( document ).on( 'click touchstart MSPointerDown', function( e )
                {
                    var resetItem = true,
                        parents	  = $( e.target ).parents();

                    for( var i = 0; i < parents.length; i++ )
                        if( parents[ i ] == curItem[ 0 ] )
                            resetItem = false;

                    if( resetItem )
                        curItem = false;
                });
            });
            return this;
        };
    })( jQuery, window, document );

    $('nav li:has(ul)').doubleTapToGo()
